import React from 'react';

export default function Logs() {
  return (
    <div style={{ margin: -24, height: 'calc(100vh - 0px)' }}>
      <iframe
        src="/logs.html"
        title="Logok"
        style={{
          width: '100%',
          height: '100vh',
          border: 'none',
          display: 'block',
        }}
      />
    </div>
  );
}
